import React, { FC, useCallback, useState } from 'react';
import styles from './index.module.scss';
import CallOffsQuickActions from './CallOffsQuickActions';
import { useActiveInboxState } from 'src/models/callOffs/hooks';
import { Button, Tooltip } from 'src/common';
import MemberList from 'src/common/MembersList';
import { useCopyToClipboard } from 'react-use';
import { useTranslation } from 'react-i18next';
import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useOpenSidebar } from 'src/shared/InfoSidebar/hooks';
import { SidebarMode } from 'src/shared/InfoSidebar/types';

export const CallOffsTitle: FC = () => {
  const { t } = useTranslation();

  const openInboxPreview = useOpenSidebar();
  const [currentInbox] = useActiveInboxState();
  const [, copyToClipboard] = useCopyToClipboard();
  const [isCopied, setIsCopied] = useState(false);

  const showDrawer = useCallback(() => {
    currentInbox && openInboxPreview({ id: currentInbox.emailAddress, mode: SidebarMode.INBOX_INFO });
  }, [openInboxPreview, currentInbox]);

  const onCopy = useCallback(() => {
    if (currentInbox?.emailAddress) {
      copyToClipboard(currentInbox.emailAddress);
      setIsCopied(true);
    }
  }, [copyToClipboard, currentInbox?.emailAddress]);

  return (
    <>
      {currentInbox && (
        <div className={styles.container}>
          <div className={styles.heading}>
            <div className={styles.title}>
              <Tooltip title={currentInbox.inboxName}>
                <span className={styles.titleName}>{currentInbox.inboxName}</span>
              </Tooltip>
            </div>
            {currentInbox.emailAddress !== currentInbox.inboxName && currentInbox.inboxName && (
              <span className={styles.subtitle}>
                {currentInbox.emailAddress}
                <Button icon={<FontAwesomeIcon icon={faCopy} />} type={'text'} onClick={onCopy}>
                  {isCopied ? t('Common.isCopied') : t('Copy email')}
                </Button>
              </span>
            )}
          </div>
          {!currentInbox.isArchived && (
            <>
              <MemberList
                owners={currentInbox.owners}
                subscribersList={currentInbox.subscribers}
                accessControlPolicy={currentInbox.accessControl.subscribePolicy}
                onClick={showDrawer}
              />
              <CallOffsQuickActions />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default CallOffsTitle;
